import { Funnel } from "@phosphor-icons/react";

const CONFIDENCE_LEVELS = ["High", "Medium", "Low"];

export default function FiltersPanel({ value, onChange, disabled }) {
    const set = (patch) => onChange({ ...value, ...patch });
    const toggleConf = (lvl) =>
        set({ confidence: { ...value.confidence, [lvl]: !value.confidence[lvl] } });

    return (
        <aside className="panel" data-testid="filters-panel">
            <div className="panel-header">
                <div className="flex items-center gap-2">
                    <Funnel size={16} weight="bold" />
                    <span className="label-kicker">Filters</span>
                </div>
            </div>
            <div className="p-5 flex flex-col gap-4 text-sm">
                <FilterToggle
                    id="require-email"
                    label="Require email"
                    checked={value.require_email}
                    onChange={(v) => set({ require_email: v })}
                    disabled={disabled}
                />
                <FilterToggle
                    id="include-phone-only"
                    label="Include phone-only results"
                    checked={value.include_phone_only}
                    onChange={(v) => set({ include_phone_only: v })}
                    disabled={disabled}
                />
                <FilterToggle
                    id="skip-no-website"
                    label="Skip businesses without websites"
                    checked={value.skip_no_website}
                    onChange={(v) => set({ skip_no_website: v })}
                    disabled={disabled}
                />
                <FilterToggle
                    id="unique-domains"
                    label="Unique domains only"
                    checked={value.unique_domains}
                    onChange={(v) => set({ unique_domains: v })}
                    disabled={disabled}
                />
                <div className="flex flex-col gap-2">
                    <span className="label-kicker">Limit Top Providers</span>
                    <input
                        type="number"
                        min={1}
                        max={500}
                        placeholder="All"
                        value={value.top_n}
                        onChange={(e) => set({ top_n: e.target.value })}
                        className="brutal-input px-3 py-2 text-sm mono"
                        data-testid="top-n-input"
                        disabled={disabled}
                    />
                </div>
                <div className="flex flex-col gap-2">
                    <span className="label-kicker">Email Confidence</span>
                    <div className="flex flex-wrap gap-2">
                        {CONFIDENCE_LEVELS.map((lvl) => {
                            const active = !!value.confidence[lvl];
                            return (
                                <button
                                    key={lvl}
                                    type="button"
                                    onClick={() => toggleConf(lvl)}
                                    disabled={disabled}
                                    className={
                                        active
                                            ? "btn-primary"
                                            : "btn-secondary"
                                    }
                                    style={{ padding: "6px 12px", fontSize: 12 }}
                                    data-testid={`conf-${lvl.toLowerCase()}-toggle`}
                                >
                                    <span
                                        className={
                                            "dot " +
                                            (lvl === "High"
                                                ? "dot-success"
                                                : lvl === "Medium"
                                                ? "dot-warning"
                                                : "dot-muted")
                                        }
                                    />
                                    {lvl}
                                </button>
                            );
                        })}
                    </div>
                    <span className="text-xs text-[#52525b]">
                        Default export: High + Medium only
                    </span>
                </div>
            </div>
        </aside>
    );
}

function FilterToggle({ id, label, checked, onChange, disabled }) {
    return (
        <label
            htmlFor={id}
            className={
                "flex items-center justify-between gap-3 cursor-pointer select-none " +
                (disabled ? "opacity-60 cursor-not-allowed" : "")
            }
        >
            <span>{label}</span>
            <span
                className="relative inline-flex items-center"
                style={{ width: 36, height: 20 }}
            >
                <input
                    id={id}
                    type="checkbox"
                    className="sr-only"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                    data-testid={`${id}-toggle`}
                />
                <span
                    style={{
                        position: "absolute",
                        inset: 0,
                        background: checked ? "#000" : "#e4e4e7",
                        transition: "background 120ms",
                    }}
                />
                <span
                    style={{
                        position: "absolute",
                        top: 2,
                        left: checked ? 18 : 2,
                        width: 16,
                        height: 16,
                        background: "#fff",
                        transition: "left 120ms",
                    }}
                />
            </span>
        </label>
    );
}
